import { Grid } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import { AISimulation } from "models/AISimulation";

const MDInput = require("components/MDInput/index.js").default;
const MDButton = require("components/MDButton/index.js").default;
export const AISimulationMessages = ({aiSimulation, setAiSimulation}: {aiSimulation: AISimulation, setAiSimulation: (aiSimulation: AISimulation) => void}) => {
    return (
        <Grid container spacing={2}>
            {(aiSimulation.messages || []).map((message, index) => (
                <Grid container spacing={1} size={12} alignItems="center" key={index}>
                    <Grid size={8}>
                        <MDInput
                            fullWidth
                            multiline
                            value={message}
                            onChange={(e) => setAiSimulation({...aiSimulation, messages: [...aiSimulation.messages.slice(0, index), e.target.value, ...aiSimulation.messages.slice(index + 1)]})}
                        />
                    </Grid>
                    <Grid size={1}>
                        <IconButton color="error" onClick={() => setAiSimulation({
                            ...aiSimulation,
                            messages: aiSimulation.messages.filter(m => m !== message)
                        })}>
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            ))}
            <Grid size={8}>
                <MDButton
                    variant="contained"
                    color="secondary"
                    onClick={() => setAiSimulation({...aiSimulation, messages: [...(aiSimulation.messages || []), ""]})}
                >
                    Add Message
                </MDButton>
            </Grid>
        </Grid>
    )
}